import NegativeMediaIgnoringPropertiesTable from './NegativeMediaIgnoringPropertiesTable';

export default NegativeMediaIgnoringPropertiesTable;


// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/negative-media-ignoring-properties/index.js